<script>
import loadingIcon from '@/assets/images/icons/loading.svg?inline'

export default {
  name: 'infinite-scroll',
  components: {
    loadingIcon,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: () => true
    },
    isLoadingBlocked: {
      type: Boolean,
      default: () => false
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        perPage: 10,
        lastPage: 1,
        total: 10
      })
    }
  },
  computed: {
    isEnd() {
      const {
        page,
        lastPage
      } = this.pagination

      return page >= lastPage
    },
  },
  methods: {
    loadMore() {
      if (!this.isLoadingBlocked) {
        this.$emit('loadMore')
      }
    },
    filtering() {
      this.$emit('filtering')
    }
  }
}
</script>

<template>
  <div class="infinite-scroll">
    <div class="infinite-scroll__content">
      <slot />
    </div>
    <div
      v-if="!isLoading && !isEnd && !isLoadingBlocked"
      class="infinite-scroll__load-more"
      @click="loadMore"
    >
      <span>Загрузить еще</span>
      <loadingIcon class="infinite-scroll__load-more--icon" />
    </div>
    <div
      v-if="isLoading"
      class="infinite-scroll__loading"
    >
      <span>Загрузка</span>
      <loadingIcon class="infinite-scroll__loading--icon" />
    </div>
    <div
      v-if="isLoadingBlocked"
      class="infinite-scroll__blocked"
    >
      <span>
        <a
          href="javascript:;"
          @click="filtering"
        >
          Примените фильтры
        </a>
        перед загрузкой новой страницы</span>
    </div>
  </div>
</template>
